import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "@teamprevent/common/healthSurveillance";

import * as questionIds from "./questionIds";

const medicalTypes = [MedicalTypeIds.ManualHandlingMSKFaceToFaceAppointment];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../consultation";` which is in a data structure suitable for use with custom medicals
 */
export const manualHandlingMSKQuestionnaireQuestions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.MSKManualHandlingAssessmentRequired,
        questionText: "Following Review of the MSK Questionnaire",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingUnableToCarryOut,
        questionText: "Unable to carry out medical",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfNeck,
        questionText: "Neck",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfBack,
        questionText: "Back",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftShoulder,
        questionText: "Left Shoulder",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftElbow,
        questionText: "Left Elbow",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfRightShoulder,
        questionText: "Right Shoulder",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfRightElbow,
        questionText: "Right Elbow",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftWrist,
        questionText: "Left Wrist",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftLeg,
        questionText: "Left Leg",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfRightWrist,
        questionText: "Right Wrist",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfRightLeg,
        questionText: "Right Leg",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDoRestrictionsAffectPerformance,
        questionText: "Do any restrictions affect the performance of your role?",
        medicalTypes
    },
    {
        id: questionIds.MSKManualHandlingDoRestrictionsAffectPerformanceNotes,
        questionText: "Details/Note",
        medicalTypes
    },
];
